import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function createCollectionConstructor(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_BEGIN,
    });
    const { projectId, version, collectionUuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/constructors/${collectionUuid}/collection`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            toast.success('Constructor Created Successfully !');
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_SUCCESS,
              data: res.data,
              collectionUuid: args.collectionUuid,
            });
            Mixpanel.track('Created collection construtor');
            resolve(res.data);
          } else {
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create collection construtor');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create collection construtor');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionConstructorError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_BEGIN:
      return {
        ...state,
        createCollectionConstructorPending: true,
        createCollectionConstructorError: null,
        showConstructorCreateLoader: true,
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        createCollectionConstructorPending: false,
        createCollectionConstructorError: null,
        showConstructorCreateLoader: false,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          constructors: action.data,
        },
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_FAILURE:
      return {
        ...state,
        createCollectionConstructorPending: false,
        createCollectionConstructorError: action.data.error,
        showConstructorCreateLoader: false,
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_DISMISS_ERROR:
      return {
        ...state,
        createCollectionConstructorError: null,
        showConstructorCreateLoader: false,
      };

    default:
      return state;
  }
}
